import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Login.css";

function Logout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from your session.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform actual logout logic here (e.g., clear tokens, session, etc.)
        navigate("/"); // Redirect to login
      }
    });
  };

  return (
    <div className="login-layout">
      {/* Left side with images */}
      <div className="login-left">
        <div className="image-grid">
          <img src="/assets/images/dada.jpeg" alt="temple" />
          <img src="/assets/images/mata1.jpeg" alt="temple" />
          <img src="/assets/images/mata.jpeg" alt="temple" />
        </div>
        <div className="guru-image">
          <img src="/assets/images/guru.jpeg" alt="temple" />
        </div>
      </div>

      {/* Right side with logout box */}
      <div className="login-right">
        <div className="logo">
          <img src="/assets/images/logo/logo1.png" alt="logo" />
          <h2>Padmavati Brothers</h2>
        </div>
        <div className="login-box">
          <h3>Click below to logout</h3>
          <button onClick={handleLogout}>LOG OUT</button>
        </div>
      </div>
    </div>
  );
}

export default Logout;
